export default function () {
  var self = this;
  var showMoreLabel = Kadenze.I18n.t('dict.show_more');
  var showLessLabel = Kadenze.I18n.t('dict.show_less');
  self.courseworkState = ko.observable(showMoreLabel);
  self.resourcesState = ko.observable(showMoreLabel);

  self.toggleCollapse = function(type){
    if(type == 'resources'){
      $('.related-material-panel__resources').toggleClass('related-material-panel__content-is-collapsed');
      if(self.resourcesState() == showMoreLabel){
        self.resourcesState(showLessLabel);
      } else {
        self.resourcesState(showMoreLabel);
      }
    } else {
      $('.related-material-panel__courseworks').toggleClass('related-material-panel__content-is-collapsed');
      if(self.courseworkState() == showMoreLabel){
        self.courseworkState(showLessLabel);
      } else {
        self.courseworkState(showMoreLabel);
      }
    }
  };

  self.resetCollapse = function() {
    $('.related-material-panel__courseworks').addClass('related-material-panel__content-is-collapsed');
    self.courseworkState(showMoreLabel);
    $('.related-material-panel__resources').addClass('related-material-panel__content-is-collapsed');
    self.resourcesState(showMoreLabel);
  };

  const __construct = function(that) {
    console.log('constructor called for RelatedMaterialPanelViewModel');
  }(this);
}
